<div class="view-dialog-container" *ngIf="form">
    <div class="header-container">
        <div class="header-title" *ngIf="!viewMode">{{ isEdit ? 'Edit Contact Details' : 'Add Contact Details' }}</div>
        <div class="header-title" *ngIf="viewMode">View Contact Details</div>
        <div class="cros-icon" (click)="onCancel()">
            <img src="assets/images/cross-icon.svg" class="cross-icon" />
        </div>
    </div>

    <form [formGroup]="form" class="d-grid" (ngSubmit)="onSave()">
        <div class="profile-scroll">
            <div class="input-card d-grid gap-14">
                <div class="form-group">
                    <app-input context="Normal" class="form-item" label="Contact name" [required]="true"
                        placeholder="Enter your contact name" type="text" [control]="form.get('name')"
                        [customErrorMessages]="customErrorMessages.name">
                    </app-input>
                </div>
                <div class="form-group">
                    <app-input context="Normal" class="form-item" label="Phone number" [required]="true"
                        placeholder="Enter your phone number" type="text" [control]="form.get('phoneNumber')"
                        [customErrorMessages]="customErrorMessages.phoneNumber">
                    </app-input>
                </div>

                <div class="form-group">
                    <app-input context="Normal" class="form-item" label="Email" placeholder="Enter your contact email"
                        [required]="true" type="email" [control]="form.get('email')"
                        [customErrorMessages]="customErrorMessages.email">
                    </app-input>
                </div>

                <div class="form-group">
                    <app-input context="Normal" class="form-item" label="Position" placeholder="Enter your position"
                        [required]="true" type="text" [control]="form.get('position')"
                        [customErrorMessages]="customErrorMessages.position">
                    </app-input>
                </div>
            </div>
        </div>

        <div class="d-flex gap-4 justify-content-center" style="padding: 1rem;" *ngIf="!viewMode">
            <button type="button" class="cancel-button" (click)="onCancel()" [disabled]="loading || isProcessing">
                Cancel
            </button>
            <button type="submit" class="update-button" [disabled]="loading || isProcessing">
                {{
                isEdit
                ? (loading || isProcessing) ? 'Updating...' : 'Update'
                : (loading || isProcessing) ? 'Submitting...' : 'Submit'
                }}
            </button>
        </div>
    </form>
</div>